<template>
  <div>
    <div class="session-detail">
      <agenda-detail
        :key="$route.params.sessionId"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import common from "../../../../helpers/common";
import AdditionalFixedTabs from "../../../../components/ui/AdditionalFixedTabs/index";
import AgendaDetail from "../../../../components/agenda/agenda-detail";
import Notify from "../../../../components/ui/Notify";

export default {
  components: {
    AdditionalFixedTabs,
    AgendaDetail,
    Notify
  },
  computed: {
    ...mapGetters('agendaStore', ['isLoadedSessionDetails']),
  },
  mounted() {
    common.setHeaderText('Session Detail');
    this.$store.commit("agendaStore/updateIsLoadedSessionDetails", true);
  }
}
</script>

<style lang="scss" scoped>

.session-detail {
  padding: var(--attendee-gap-md);
  background-color: white;
  border-radius: var(--attendee-card-border-radius);
  box-shadow: var(--attendee-box-shadow);
  //overflow: hidden;

  @media (max-width: 900px) {
    margin-top: 0;
    box-shadow: none;
    padding-top: 0;
  }
}
</style>
